import React from "react";
import { useEffect, useState } from "react";
import axios from "axios";
import AuthUser from "./AuthUser";
import toast, { Toaster } from "react-hot-toast";
import { useNavigate } from "react-router-dom";

export default function Tasks() {
  const navigate = useNavigate();
  const { http, user } = AuthUser();
  const [formData, setFormData] = useState({
    description: "",
    department_id: "",
    target_date: "",
    additional_info: "",
    task_weightage: "3",
    priority: "Medium",
    assigned_by: user.id,
    assigned_to: "",
    task_file: "",
    est_time: "1",
  });

  const initialState = {
    description: "",
    department_id: "",
    target_date: "",
    additional_info: "",
    task_weightage: "3",
    priority: "Medium",
    assigned_by: user.id,
    assigned_to: "",
    task_file: "",
    est_time: "1",
  };

  const [departmetsall, setdepartmentsall] = useState([]);
  const [department, setDepartment] = useState([]);
  const [users, setUsers] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState(null);

  useEffect(() => {
    http.get(`/departments?login_user=${user.id}`).then((res) => {
      setdepartmentsall(res.data.data);
    });
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    if (e.target.name === "department_id") {
      fetchUsersForDepartment(e.target.value);
    }
  };

  const fetchUsersForDepartment = async (departmentId) => {
    try {
      const response = await http.get(
        `/department_user?department=${departmentId}&login_user=${user.id}`
      );
      setUsers(response.data.users);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const form = new FormData();
    for (const key in formData) {
      form.append(key, formData[key]);
    }

    const taskFileInput = document.querySelector('input[type="file"]');
    if (taskFileInput.files[0])
      form.append("task_file", taskFileInput.files[0]);

    try {
      http
        .post("/tasks", form, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => {
          toast.success("Task added successfully !");
          setFormData(initialState);
          navigate("/dashboard");
        });
    } catch (error) {
      console.error("Error adding task:", error.response.data);
    }
  };

  return (
    <>
      <div className="container mt-5">
        <Toaster />
        <h1>Add Task</h1>
        <form onSubmit={handleSubmit}>
          <div className="form-group mt-3">
            <label>Department</label>
            <select
              name="department_id"
              className="form-control"
              value={formData.department_id}
              onChange={handleChange}
              required
            >
              <option value="">Select Department</option>
              {departmetsall.map((depart) => (
                <option key={depart.id} value={depart.id}>
                  {depart.name}
                </option>
              ))}
            </select>
          </div>



          <div className="form-group  mt-3">
            <label>Assigned To</label>
            <select
              disabled={!users.length}
              name="assigned_to"
              className="form-control text-uppercase"
              value={formData.assigned_to}
              onChange={handleChange}
              required
            >
              <option value="">Select a user</option>
              {users.map((user) => (
                <option key={user.id} value={user.id}>
                  {user.name} {user.last_name}
                </option>
              ))}
            </select>
          </div>

          {user.company_id == 1 && (
            <div className="form-group  mt-2">
              <label>Establish Time</label>
              <select
                name="est_time"
                onChange={handleChange}
                className="form-control"
                value={formData.est_time}
                required
              >
                <option value="0">0 Hour</option>
                <option value="1">1 Hour</option>
                <option value="2">2 Hour</option>
                <option value="3">3 Hour</option>
                <option value="4">4 Hour-Half day</option>
                <option value="5">5 Hour</option>
                <option value="6">6 Hour</option>
                <option value="7">7 Hour</option>
                <option value="8">8 Hour</option>
              </select>
            </div>
          )}

          <div className="form-group mt-3">
            <label>Description</label>
            <textarea
              name="description"
              className="form-control"
              value={formData.description}
              onChange={handleChange}
              rows="2"
            />
          </div>

          <div className="form-group  mt-3">
            <label>Target Date</label>
            <input
              name="target_date"
              className="form-control"
              type="date"
              value={formData.target_date}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group mt-3">
            <label>Additional Info</label>
            <textarea
              name="additional_info"
              className="form-control"
              value={formData.additional_info}
              onChange={handleChange}
              rows="2"
            />
          </div>

          <div className="form-group  mt-3">
            <label>Task Weightage</label>
            <select
              name="task_weightage"
              className="form-control"
              value={formData.task_weightage}
              onChange={handleChange}
              required
            >
              <option value="">Select a weightage</option>
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
              <option value="4">4</option>
              <option value="5">5</option>
            </select>
          </div>

          <div className="form-group  mt-3">
            <label>Priority</label>
            <select
              name="priority"
              className="form-control"
              value={formData.priority}
              onChange={handleChange}
              required
            >
              <option value="">Select a Priority</option>
              <option value="High">High</option>
              <option value="Medium">Medium</option>
              <option value="Low">Low</option>
            </select>
          </div>

          <div className="form-group mt-3">
            <label>Task Files</label>
            <input type="file" className="form-control" />
          </div>
          <button className="btn button btn-success mt-3" type="submit">
            Add Task
          </button>
        </form>
      </div>

            <style jsx>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');
        
        .invoice-fields-container {
          background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 50%, #f1f5f9 100%);
          border-radius: 25px;
          padding: 30px;
          border: 2px solid #e2e8f0;
          box-shadow: 0 20px 60px rgba(148, 163, 184, 0.15);
          position: relative;
          overflow: hidden;
          animation: slideInUp 0.8s ease-out;
        }

        .invoice-fields-container::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="grain" width="100" height="100" patternUnits="userSpaceOnUse"><circle cx="25" cy="25" r="1" fill="rgba(71,85,105,0.05)"/><circle cx="75" cy="75" r="1" fill="rgba(71,85,105,0.05)"/><circle cx="50" cy="10" r="0.5" fill="rgba(71,85,105,0.03)"/></pattern></defs><rect width="100" height="100" fill="url(%23grain)"/></svg>');
          pointer-events: none;
        }

        @keyframes slideInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes pulse {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.05); }
        }

        @keyframes glow {
          0%, 100% { box-shadow: 0 0 20px rgba(59, 130, 246, 0.2); }
          50% { box-shadow: 0 0 30px rgba(59, 130, 246, 0.3); }
        }

        .invoice-header {
          background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%) !important;
          box-shadow: 0 15px 35px rgba(59, 130, 246, 0.2);
          border-radius: 20px !important;
          position: relative;
          overflow: hidden;
          animation: glow 3s ease-in-out infinite;
        }

        .invoice-header::before {
          content: '';
          position: absolute;
          top: -50%;
          left: -50%;
          width: 200%;
          height: 200%;
          background: linear-gradient(45deg, transparent, rgba(255,255,255,0.2), transparent);
          animation: shimmer 3s linear infinite;
        }

        @keyframes shimmer {
          0% { transform: translateX(-100%) translateY(-100%) rotate(45deg); }
          100% { transform: translateX(100%) translateY(100%) rotate(45deg); }
        }

        .invoice-header h4 {
          position: relative;
          z-index: 2;
          text-shadow: 0 2px 4px rgba(0,0,0,0.3);
          font-family: 'Inter', sans-serif;
          font-weight: 700;
          letter-spacing: 1px;
        }

        .modern-card {
          background: linear-gradient(135deg, rgba(255,255,255,0.98) 0%, rgba(248,250,252,0.98) 100%);
          border: 1px solid rgba(226, 232, 240, 0.8);
          border-radius: 20px;
          box-shadow: 0 10px 40px rgba(71, 85, 105, 0.08);
          transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
          position: relative;
          overflow: hidden;
          height: 100%;
          backdrop-filter: blur(10px);
        }

        .modern-card::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 4px;
          background: linear-gradient(90deg, #3b82f6, #10b981, #06b6d4, #8b5cf6, #f59e0b);
          background-size: 300% 100%;
          animation: gradientMove 3s ease infinite;
        }

        @keyframes gradientMove {
          0%, 100% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
        }

        .modern-card::after {
          content: '';
          position: absolute;
          top: 10px;
          right: 10px;
          width: 6px;
          height: 6px;
          background: linear-gradient(45deg, #3b82f6, #1d4ed8);
          border-radius: 50%;
          opacity: 0.5;
        }

        .modern-card:hover {
          transform: translateY(-8px) scale(1.02);
          box-shadow: 0 20px 60px rgba(71, 85, 105, 0.12);
          background: linear-gradient(135deg, rgba(255,255,255,1) 0%, rgba(248,250,252,1) 100%);
        }

        .modern-card:hover::before {
          height: 6px;
          animation-duration: 1.5s;
        }

        .modern-input {
          border: 2px solid rgba(148, 163, 184, 0.3);
          border-radius: 15px;
          padding: 15px 20px;
          font-size: 14px;
          font-family: 'Inter', sans-serif;
          font-weight: 500;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          background: rgba(255, 255, 255, 0.95);
          backdrop-filter: blur(5px);
          position: relative;
          color: #334155;
        }

        .modern-input:focus {
          border-color: #3b82f6;
          box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.1), 0 8px 25px rgba(59, 130, 246, 0.08);
          transform: translateY(-2px);
          outline: none;
          background: rgba(255, 255, 255, 1);
        }

        .modern-input::placeholder {
          color: rgba(100, 116, 139, 0.6);
          font-style: italic;
        }

        .form-label {
          font-size: 15px;
          margin-bottom: 10px;
          display: flex;
          align-items: center;
          gap: 8px;
          font-family: 'Inter', sans-serif;
          font-weight: 600;
          color: #2d3748;
          text-shadow: 0 1px 2px rgba(0,0,0,0.1);
        }

        .text-primary {
          background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }

        .fw-bold {
          font-weight: 700 !important;
        }

        .border-2 {
          border-width: 3px !important;
        }

        .bg-gradient {
          background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
        }

        .text-white {
          color: white !important;
        }

        .text-center {
          text-align: center;
        }

        .mb-0 {
          margin-bottom: 0 !important;
        }

        .p-3 {
          padding: 1.5rem !important;
        }

        .mb-3 {
          margin-bottom: 1.5rem !important;
        }

        .mb-4 {
          margin-bottom: 2rem !important;
        }

        .mt-4 {
          margin-top: 2rem !important;
        }

        .rounded-3 {
          border-radius: 1rem !important;
        }

        .border-primary {
          border-color: #3b82f6 !important;
        }

        .modern-radio-group {
          display: flex;
          flex-direction: column;
          gap: 12px;
        }

        .modern-radio-group .form-check-inline {
          margin-right: 20px;
          padding: 8px 15px;
          border-radius: 25px;
          transition: all 0.3s ease;
          background: rgba(59, 130, 246, 0.05);
        }

        .modern-radio-group .form-check-inline:hover {
          background: rgba(59, 130, 246, 0.1);
          transform: translateX(3px);
        }

        .modern-radio {
          width: 20px;
          height: 20px;
          margin-right: 10px;
          border: 2px solid #3b82f6;
        }

        .modern-radio:checked {
          background-color: #3b82f6;
          border-color: #3b82f6;
          box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.15);
          animation: pulse 0.6s ease-in-out;
        }

        .modern-label {
          font-weight: 500;
          color: #475569;
          cursor: pointer;
          transition: all 0.3s ease;
        }

        .modern-label:hover {
          color: #3b82f6;
        }

        .pricing-card {
          background: linear-gradient(135deg, rgba(59,130,246,0.05) 0%, rgba(16,185,129,0.05) 50%, rgba(6,182,212,0.05) 100%);
          border: 2px solid rgba(148, 163, 184, 0.2);
          background-clip: padding-box;
          position: relative;
        }

        .pricing-card::before {
          content: '';
          position: absolute;
          inset: 0;
          padding: 2px;
          background: linear-gradient(135deg, #3b82f6, #10b981, #06b6d4);
          border-radius: inherit;
          mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
          mask-composite: xor;
          -webkit-mask-composite: xor;
        }

        .pricing-options {
          display: flex;
          flex-direction: column;
          gap: 15px;
        }

        .pricing-option {
          margin-bottom: 20px;
          padding: 20px;
          border: 2px solid rgba(148, 163, 184, 0.2);
          border-radius: 15px;
          transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
          cursor: pointer;
          background: rgba(255, 255, 255, 0.9);
          backdrop-filter: blur(10px);
          position: relative;
          overflow: hidden;
        }

        .pricing-option::before {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(59, 130, 246, 0.08), transparent);
          transition: left 0.5s ease;
        }

        .pricing-option:hover::before {
          left: 100%;
        }

        .pricing-option:hover {
          border-color: #3b82f6;
          background: rgba(59, 130, 246, 0.05);
          transform: translateX(8px) scale(1.02);
          box-shadow: 0 10px 30px rgba(59, 130, 246, 0.15);
        }

        .pricing-option input:checked + .pricing-label {
          color: #3b82f6;
          font-weight: 700;
        }

        .pricing-label {
          display: flex;
          align-items: center;
          margin-bottom: 0;
          font-size: 16px;
          font-weight: 600;
          position: relative;
          z-index: 2;
        }

        .pricing-icon {
          margin-right: 12px;
          font-size: 24px;
          animation: bounce 2s infinite;
        }

        @keyframes bounce {
          0%, 20%, 50%, 80%, 100% { transform: translateY(0); }
          40% { transform: translateY(-5px); }
          60% { transform: translateY(-3px); }
        }

        .message-card {
          background: linear-gradient(135deg, rgba(40, 167, 69, 0.1) 0%, rgba(255, 255, 255, 0.95) 100%);
          border: 2px solid rgba(40, 167, 69, 0.3);
          position: relative;
          overflow: hidden;
        }

        .message-card::before {
          content: '💬';
          position: absolute;
          top: -10px;
          right: -10px;
          font-size: 40px;
          opacity: 0.1;
          animation: float 3s ease-in-out infinite;
        }

        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-10px); }
        }

        .text-success {
          background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }

        .border-success {
          border-color: #28a745 !important;
        }

        .g-3 > * {
          padding: 1rem;
        }

        /* Enhanced section headers */
        .section-divider {
          height: 2px;
          background: linear-gradient(90deg, transparent, #667eea, transparent);
          margin: 30px 0;
          border-radius: 2px;
        }

        /* Floating animation for form elements */
        .modern-card:nth-child(odd) {
          animation: floatLeft 6s ease-in-out infinite;
        }

        .modern-card:nth-child(even) {
          animation: floatRight 6s ease-in-out infinite;
        }

        @keyframes floatLeft {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-3px); }
        }

        @keyframes floatRight {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(3px); }
        }

        /* Improved typography */
        * {
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
        }

        /* Enhanced focus states */
        .modern-input:focus,
        .modern-radio:focus,
        select:focus {
          animation: focusPulse 0.3s ease-in-out;
        }

        @keyframes focusPulse {
          0% { transform: scale(1); }
          50% { transform: scale(1.02); }
          100% { transform: scale(1); }
        }

        /* Gradient text for labels */
        .form-label::before {
          content: attr(data-icon);
          margin-right: 8px;
          font-size: 18px;
          filter: drop-shadow(0 2px 4px rgba(0,0,0,0.1));
        }
      `}</style>
    </>
  );
}
